const CONSTANTS = {
  ACCORDION_INTERVAL: 5000,
  METADATA_API_POLLING: 120000,
};

export default CONSTANTS;
